import styled from 'styled-components';
import { COLORS } from '@bikdotai/bik-component-library';

export const ModalOuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 70vh;
  background: ${COLORS.surface.standard};
  border-radius: 0;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 20px 24px;
  border-bottom: 1px solid ${COLORS.stroke.primary};
  background: ${COLORS.surface.standard};
`;

export const ModalHeaderTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: ${COLORS.content.primary};
  margin: 0;
`;

export const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  min-height: 350px;
  background: ${COLORS.surface.standard};

  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: ${COLORS.surface.subdued};
  }
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.content.inactive};
    border-radius: 4px;
  }
`;

export const ModalFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DropdownContainer = styled.div`
  width: 100%;
`;

export const ModalFooter = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid ${COLORS.stroke.primary};
  background: ${COLORS.surface.standard};
  justify-content: flex-end;
`;

export const TeamsAgentsSection = styled.div`
  margin-top: 16px;
  position: relative;
`;

export const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 200;
`;

export const PopupWrapper = styled.div`
  position: fixed;
  width: 366px;
  z-index: 201;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
`;

export const PopupTabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  padding: 0 16px;
`;

export const PopupTab = styled.div<{ $active: boolean }>`
  flex: 1;
  padding: 12px 0;
  text-align: center;
  cursor: pointer;
  border-bottom: ${({ $active }) =>
    $active ? `2px solid ${COLORS.content.brand}` : 'none'};
  color: ${({ $active }) =>
    $active ? COLORS.content.primary : COLORS.content.secondary};
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  font-size: 14px;
`;

export const PopupSearchWrapper = styled.div`
  padding: 12px 16px;
`;

export const PopupSearchInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid ${COLORS.content.secondary};
  border-radius: 6px;
  font-size: 14px;
  outline: none;
`;

export const SelectAllRow = styled.div`
  padding: 8px 16px;
  border-bottom: 1px solid ${COLORS.stroke.primary};
`;

export const SelectAllContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
`;

export const PopupList = styled.div`
  max-height: 240px;
  overflow-y: auto;
`;

export const PopupListItem = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  cursor: pointer;
  background: ${({ $selected }) =>
    $selected
      ? COLORS?.background?.positive?.light
      : 'transparent'};
  transition: background 0.15s;

  &:hover {
    background: ${({ $selected }) =>
      $selected
        ? COLORS?.background?.positive?.light
        : '#F5F5F5'};
  }
`;

export const PopupFooter = styled.div`
  border-top: 1px solid #e0e0e0;
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
`;

export const EmptyResults = styled.div`
  padding: 20px;
  text-align: center;
  color: ${COLORS.content.secondary};
`;
